import React, { useContext } from "react";
import Button from "../Button/Button";
import styled from "styled-components";
import { Auth } from "aws-amplify";
import { UserData } from "../../context";
import { Container, Row, Col } from "reactstrap";

const Navbar = () => {
  const user = useContext(UserData) || {};

  async function handleSignout() {
    try {
      await Auth.signOut();
    } catch (err) {
      console.error("Error signing out user", err);
    }
  }

  let environment = user && user.config && user.config.env;
  if (environment === undefined || environment === "prod") {
    environment = "";
  } else {
    environment = ` - ${environment}`;
  }

  return (
    <NavWrapper>
      <Container fluid>
        <Row>
          <Col>
            <div style={{ float: "right" }}>
              <Greeting>{`Hello, ${user.username}${environment}`}</Greeting>
              <VerticalAlign>
                <Button round color="#23B6EA" small click={handleSignout}>
                  Sign Out
                </Button>
              </VerticalAlign>
            </div>
          </Col>
        </Row>
      </Container>
    </NavWrapper>
  );
};

const NavWrapper = styled.div`
  height: 50px;
  position: fixed;
  top: 0px;
  left: 190px;
  right: 0px;
  background: #fff;
  line-height: 50px;
  /* color: #fff; */
  padding: 0px 20px;
  z-index: 5000;
`;

const Greeting = styled.div`
  display: inline-block;
  margin-right: 20px;
  vertical-align: top;
`;

const VerticalAlign = styled.div`
  display: inline-block;
  padding-top: 10px;
  height: 50px;
  vertical-align: top;
`;

export default Navbar;
